import './App.css';

import React, { useState, useRef } from 'react';

import ReCAPTCHA from 'react-google-recaptcha';

import axios from 'axios';

const Animation = () => {

  return (
    <div className = "center" id="animation">
      <img src='https://cdn.shopify.com/s/files/1/0737/7194/2200/files/quill_gif.gif?v=1682433720' alt="quill animation" />
    </div>
  )
}

const EmailHeader = () => {
  return (
    <div>
      <h2 className = "custom_email_header">Bravo! Memorialize this moment.</h2>
      <h2 className = "custom_email_header">Email yourself this poetic mastery for safekeeping and sharing.</h2>
    </div>
  )
}




const Output = (props) => {

  return (
    <div id = "output" className="center">
      <p className="display-linebreak">{props.output}</p>
    </div>
  )
}

const Header = () => {
  
  return (
    <div>
      <h1>PoemAI Generator</h1>
    </div> 
  )

}

const EmailMe = (props) => {
  const [email, setEmail] = useState(''); 

  const emailPoem = async (event) => {
    event.preventDefault();

    const poem = props.poem;
    const type = props.type;

    let profile = {
      poem: poem,
      email: email,
      type: type
    }

    try {
      const response = await axios.post('/email', profile);
      console.log(response.data);
      window.location.replace('https://cdn.shopify.com/s/files/1/0737/7194/2200/files/58442955-ED77-4714-BEFA-5D1302AB588C_1_201_a.jpg?v=1682439155');
    } 
    
    catch (error) {
      console.error(error);
    }
  }


  return (
    <div className="dynamic_form">
      <form className="sub_form" onSubmit={emailPoem} action='https://www.poemai.com/thankyou/'>
        <label>
          <input required
          type="email"
          id = "email" 
          name="email" 
          value={email} 
          onChange={(event) => setEmail(event.target.value)}>
        </input>
        </label>
        <label>
          <input required type="checkbox" id="consent"></input>
          I accept the <u>terms and conditions</u>, and agree to <u>opt in to the GiftAI email list</u>. By accepting these terms I understand I may receive promotional emails from time to time.
        </label>
        <br></br>
        <br></br>
        <input className="button" type="submit" value="Email Me My Poem"/>
      </form>
    </div>
  )
  
}

const Form = (props) => {
  let [formVisible, setFormVisible] = useState(true);
  let [isAnimating, setIsAnimating] = useState(false);

  const [formType, setFormType] = useState('self');
  const [toneType, setToneType] = useState('self');
  const [poemStructure, setPoemStructure] = useState('self');

  const [spouseVisible, setSpouseVisible] = useState(false);
  const [friendVisible, setFriendVisible] = useState(false);
  const [petVisible, setPetVisible] = useState(false);
  const [momVisible, setMomVisible] = useState(false);
  const [dadVisible, setDadVisible] = useState(false);

  // spouse
  const [spouseName, setSpouseName] = useState('');
  const [spouseLooks, setSpouseLooks] = useState('');
  const [spouseTraits, setSpouseTraits] = useState('');
  const [spouseHobbies, setSpouseHobbies] = useState('');
  const [spousePlace, setSpousePlace] = useState('');
  const [spouseMeet, setSpouseMeet] = useState('');
  const [spouseLength, setSpouseLength] = useState('');
  const [spouseLongAnswer, setSpouseLongAnswer] = useState('');

  // spouse radio buttons
  const [spouseGender, setSpouseGender] = useState('');
  const [spouseAge, setSpouseAge] = useState('');

  // friend
  const [friendName, setFriendName] = useState('');
  const [friendLooks, setFriendLooks] = useState('');
  const [friendTraits, setFriendTraits] = useState('');
  const [friendHobbies, setFriendHobbies] = useState('');
  const [friendPlace, setFriendPlace] = useState('');
  const [friendLength, setFriendLength] = useState('');
  const [friendLongAnswer, setFriendLongAnswer] = useState('');

  // friend radio buttons
  const [friendGender, setFriendGender] = useState('');
  const [friendAge, setFriendAge] = useState('');

  // pet 
  const [petName, setPetName] = useState('');
  const [petBreed, setPetBreed] = useState('');
  const [petTraits, setPetTraits] = useState('');
  const [petHobbies, setPetHobbies] = useState('');
  const [petLooks, setPetLooks] = useState('');
  const [petFriends, setPetFriends] = useState('');
  const [petLongAnswer, setPetLongAnswer] = useState('');

  // pet radio buttons
  const [petGender, setPetGender] = useState('');
  const [petSpecies, setPetSpecies] = useState('');

  // mom
  const [momName, setMomName] = useState('');
  const [momLooks, setMomLooks] = useState('');
  const [momTraits, setMomTraits] = useState('');
  const [momHobbies, setMomHobbies] = useState('');
  const [momPlace, setMomPlace] = useState('');
  const [momKids, setMomKids] = useState('');
  const [momLongAnswer, setMomLongAnswer] = useState('');

  // mom radio buttons
  const [momAge, setMomAge] = useState('');

   // dad
   const [dadName, setDadName] = useState('');
   const [dadLooks, setDadLooks] = useState('');
   const [dadTraits, setDadTraits] = useState('');
   const [dadHobbies, setDadHobbies] = useState('');
   const [dadPlace, setDadPlace] = useState('');
   const [dadKids, setDadKids] = useState('');
   const [dadLongAnswer, setDadLongAnswer] = useState('');

   // dad radio buttons
   const [dadAge, setDadAge] = useState('');


  const reRef = useRef();

  const createPoem = async (event) => {
    event.preventDefault();

    console.log('Creating poem...');

    

    const token = await reRef.current.executeAsync();

    //console.log("Token: " + token);

    reRef.current.reset();
    


    let poem = "";


    if (formType === 'spouse') {
      console.log("spouse selected");
      let type = "spouse";
      poem = {
        type: type,
        tone: toneType,
        poemStructure: poemStructure,
        spouseName: spouseName,
        spouseLooks: spouseLooks,
        spouseTraits: spouseTraits,
        spouseHobbies: spouseHobbies,
        spousePlace: spousePlace,
        spouseMeet: spouseMeet,
        spouseLength: spouseLength,
        spouseAge: spouseAge,
        spouseGender: spouseGender,
        spouseLongAnswer: spouseLongAnswer,
        token
      };
    }
    else if (formType === 'friend') {
      console.log("friend selected");
      let type = "friend";
      poem = {
        type: type,
        tone: toneType,
        poemStructure: poemStructure,
        friendName: friendName,
        friendLooks: friendLooks,
        friendTraits: friendTraits,
        friendHobbies: friendHobbies,
        friendPlace: friendPlace,
        friendLength: friendLength,
        friendAge: friendAge,
        friendGender: friendGender,
        friendLongAnswer: friendLongAnswer,
        token
      };
    }
    else if (formType === 'pet') {
      console.log("pet selected");
      const type = "pet";
      poem = {
        type: type,
        tone: toneType,
        poemStructure: poemStructure,
        petName: petName,
        petBreed: petBreed,
        petTraits: petTraits,
        petHobbies: petHobbies,
        petLooks: petLooks,
        petFriends: petFriends,
        petGender: petGender,
        petSpecies: petSpecies,
        petLongAnswer: petLongAnswer,
        token
      };
    }
    else if (formType === 'mom') {
      console.log("mom selected");
      const type = "mom";
      poem = {
        type: type,
        tone: toneType,
        poemStructure: poemStructure,
        momName: momName,
        momAge: momAge,
        momLooks: momLooks,
        momTraits: momTraits,
        momHobbies: momHobbies,
        momPlace: momPlace,
        momKids: momKids,
        momLongAnswer: momLongAnswer,
        token
      };
    }
    else if (formType === 'dad') {
      console.log("dad selected");
      const type = "dad";
      poem = {
        type: type,
        tone: toneType,
        poemStructure: poemStructure,
        dadName: dadName,
        dadAge: dadAge,
        dadLooks: dadLooks,
        dadTraits: dadTraits,
        dadHobbies: dadHobbies,
        dadPlace: dadPlace,
        dadKids: dadKids,
        dadLongAnswer: dadLongAnswer,
        token
      };
    }
    else if (formType === 'self') {
      console.log("self selected")
      alert("Please select a value from the dropdown menu")
      window.location.reload(false);
    }

    console.log("Poem: " + poem);
    setFormVisible(!formVisible);
    setIsAnimating(!isAnimating);

    let poemType = '';

    if (formType === "pet") {
      poemType = petSpecies;
    } else {
      poemType = formType;
    }


  

    
  
    try {
      const response = await axios.post('/api', poem, {
        headers: {
          // Overwrite Axios's automatically set Content-Type
          'Content-Type': 'application/json'
        }
      });
      props.grabPoem(response.data);
      props.grabType(poemType);
      props.hideForm(false);
      setIsAnimating(!isAnimating);
      console.log(response.data);
      
    } 
    
    catch (error) {
      console.error(error);
    }
  };
  
  const handleFormTypeChange = event => {
      setFormType(event.target.value);
      setSpouseVisible(false);
      setFriendVisible(false);
      setPetVisible(false);
      if (event.target.value === 'spouse') {
        setSpouseVisible(!spouseVisible);
    } else if (event.target.value === 'friend') {
        setFriendVisible(!friendVisible);
    } else if (event.target.value === 'pet') {
        setPetVisible(!petVisible);
  }
  else if (event.target.value === 'mom') {
    setMomVisible(!momVisible);
  }
  else if (event.target.value === 'dad') {
    setDadVisible(!dadVisible);
  }
  }

  const handleToneTypeChange = (event) => {
    setToneType(event.target.value);
}

const handlePoemStructureChange = (event) => {
  setPoemStructure(event.target.value);
}

  const handleSpouseGender = (event) => {
    setSpouseGender(event.target.value);
  };

  const handleSpouseAge = (event) => {
    setSpouseAge(event.target.value);
  };

  const handleFriendGender = (event) => {
    setFriendGender(event.target.value);
  };

  const handleFriendAge = (event) => {
    setFriendAge(event.target.value);
  };

  const handlePetGender = (event) => {
    setPetGender(event.target.value);
  };

  const handlePetSpecies = (event) => {
    setPetSpecies(event.target.value);
  };

  const handleMomAge = (event) => {
    setMomAge(event.target.value);
  };

  const handleDadAge = (event) => {
    setDadAge(event.target.value);
  };

  return (
    <div className="dynamic_form">
      {formVisible && 
      <div className="dynamic_form">
        <Header></Header>
          <form onSubmit={createPoem}>
              <label>
                  Poem Type:
                  <select value={formType} onChange={handleFormTypeChange}>
                      <option value="self">Choose 1 option.</option>
                      <option value="spouse">Romantic Partner</option>
                      <option value="mom">Mother</option>
                      <option value="dad">Father</option>
                      <option value="pet">Pet</option>
                      <option value="friend">Friend</option>
                      
                  </select>
              </label>
              {formType === 'self' &&
                  <div>
                      <br />
                  </div>
              }
              {formType === 'spouse' && spouseVisible &&
                  <div className="sub_form">
                    <label>
                  Tone:
                  <select value={toneType} onChange={handleToneTypeChange}>
                      <option value="detailed">Classic</option>
                      <option value="shakespearean">Shakespearean</option>
                      <option value="humorous">Humorous</option>
                      <option value="satirical">Satirical</option>
                      <option value="epic">Epic</option>
                      <option value="dark">Dark</option>
                      <option value="friendly">Friendly</option>
                      <option value="romantic">Romantic</option>
                  </select>
              </label>
              <label>
                  Structure:
                  <select value={poemStructure} onChange={handlePoemStructureChange}>
                      <option value="poem">Poem</option>
                      <option value="haiku">Haiku</option>
                  </select>
              </label>
                      <label>
            <p>Partner's Name:</p>
            <input id = "spouseName" 
            name="spouseName" 
            value={spouseName} 
            onChange={(event) => setSpouseName(event.target.value)}
            required
            ></input>
          </label>
          <div className="radio">
            <p>Partner's Gender: </p>
        <label>
          <input
            type="radio"
            value="male"
            name="spouseGender"
            checked={spouseGender === 'male'}
            onChange={handleSpouseGender}
          />
          Male
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="female"
            name="spouseGender"
            checked={spouseGender === 'female'}
            onChange={handleSpouseGender}
          />
          Female
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="other"
            name="spouseGender"
            checked={spouseGender === 'other'}
            onChange={handleSpouseGender}
            />
          Other
        </label>
      </div>
      <div className="radio">
        <p>Partner's Age: </p>
        <label>
          <input
            type="radio"
            value="teen"
            name="spouseAge"
            checked={spouseAge === 'teen'}
            onChange={handleSpouseAge}
          />
          Teen 12-19
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="young"
            name="spouseAge"
            checked={spouseAge === 'young'}
            onChange={handleSpouseAge}
          />
          Young 20-30
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="adult"
            name="spouseAge"
            checked={spouseAge === 'adult'}
            onChange={handleSpouseAge}
            />
          Adult 30-65
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="elder"
            name="spouseAge"
            checked={spouseAge === 'elder'}
            onChange={handleSpouseAge}
            />
          Elder 65+
        </label>
      </div>
          <label>
            <p>What do you like about your partner's appearance?</p>
            <input required id = "spouseLooks" 
            name="spouseLooks" 
            value={spouseLooks} 
            onChange={(event) => setSpouseLooks(event.target.value)}></input>
          </label>
          <label>
            <p>What personality traits do you like?</p>
            <input required id = "spouseTraits" 
            name="spouseTraits" 
            value={spouseTraits} 
            onChange={(event) => setSpouseTraits(event.target.value)}></input>
          </label>
          <label>
            <p>What are their hobbies?</p>
            <input required id = "spouseHobbies" 
            name="spouseHobbies" 
            value={spouseHobbies} 
            onChange={(event) => setSpouseHobbies(event.target.value)}></input>
          </label>
          <label>
            <p>What is their favorite place to travel or hang out?</p>
            <input id = "spousePlace" 
            name="spousePlace" 
            value={spousePlace} 
            onChange={(event) => setSpousePlace(event.target.value)}
            required></input>
          </label>
          <label>
            <p>Where did you first meet?</p>
            <input id = "spouseMeet" 
            name="spouseMeet" 
            value={spouseMeet} 
            onChange={(event) => setSpouseMeet(event.target.value)}
            required></input>
          </label>
          <label>
            <p>How long have you been together?</p>
            <input id = "spouseLength" 
            name="spouseLength" 
            value={spouseLength} 
            onChange={(event) => setSpouseLength(event.target.value)}
            required></input>
          </label>
          <label>
            <p>One of our fondest memories together is (This answer is optional but greatly increases the quality of the AI response): </p>
            <textarea
            rows="5" cols="50"
            id = "spouseLongAnswer" 
            name="spouseLongAnswer" 
            value={spouseLongAnswer} 
            onChange={(event) => setSpouseLongAnswer(event.target.value)}>
            </textarea>
          </label>
                  </div>
              }
              {formType === 'friend' && friendVisible &&
                  <div>
                    <label>
                  Tone:
                  <select value={toneType} onChange={handleToneTypeChange}>
                      <option value="detailed">Classic</option>
                      <option value="shakespearean">Shakespearean</option>
                      <option value="humorous">Humorous</option>
                      <option value="satirical">Satirical</option>
                      <option value="epic">Epic</option>
                      <option value="dark">Dark</option>
                      <option value="friendly">Friendly</option>
                      <option value="romantic">Romantic</option>
                  </select>
              </label>
              <label>
                  Structure:
                  <select value={poemStructure} onChange={handlePoemStructureChange}>
                      <option value="poem">Poem</option>
                      <option value="haiku">Haiku</option>
                  </select>
              </label>
                      <label>
            <p>Friends's Name:</p>
            <input id = "friendName" 
            name="friendName" 
            value={friendName} 
            onChange={(event) => setFriendName(event.target.value)}
            required></input>
          </label>
          <div className="radio">
            <p>Friends's Gender: </p>
        <label>
          <input
            type="radio"
            value="Male"
            name="friendGender"
            checked={friendGender === 'Male'}
            onChange={handleFriendGender}
          />
          Male
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="Female"
            name="friendGender"
            checked={friendGender === 'Female'}
            onChange={handleFriendGender}
          />
          Female
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="Other"
            name="friendGender"
            checked={friendGender === 'Other'}
            onChange={handleFriendGender}
            />
          Other
        </label>
      </div>
      <div className="radio">
        <p>Friend's Age: </p>
        <label>
          <input
            type="radio"
            value="teen"
            name="friendAge"
            checked={friendAge === 'teen'}
            onChange={handleFriendAge}
          />
          Teen 12-19
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="young"
            name="friendAge"
            checked={friendAge === 'young'}
            onChange={handleFriendAge}
          />
          Young 20-30
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="adult"
            name="friendAge"
            checked={friendAge === 'adult'}
            onChange={handleFriendAge}
            />
          Adult 30-65
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="elder"
            name="friendAge"
            checked={friendAge === 'elder'}
            onChange={handleFriendAge}
            />
          Elder 65+
        </label>
      </div>
          <label>
            <p>Describe their physical appearance:</p>
            <input id = "friendLooks" 
            name="friendLooks" 
            value={friendLooks} 
            onChange={(event) => setFriendLooks(event.target.value)}
            required></input>
          </label>
          <label>
            <p>One or two things you like about their personality:</p>
            <input id = "friendTraits" 
            name="friendTraits" 
            value={friendTraits} 
            onChange={(event) => setFriendTraits(event.target.value)}
            required></input>
          </label>
          <label>
            <p>What are one or two hobbies they like to do?</p>
            <input id = "friendHobbies" 
            name="friendHobbies" 
            value={friendHobbies} 
            onChange={(event) => setFriendHobbies(event.target.value)}
            required></input>
          </label>
          <label>
            <p>What is their favorite place to travel or hang out?
            </p>
            <input id = "friendPlace" 
            name="friendPlace" 
            value={friendPlace} 
            onChange={(event) => setFriendPlace(event.target.value)}
            required></input>
          </label>
          <label>
            <p>How long have you been friends?</p>
            <input id = "friendLength" 
            name="friendLength" 
            value={friendLength} 
            onChange={(event) => setFriendLength(event.target.value)}
            required></input>
          </label>
          <label>
            <p>Recall a fun time you had together. Share the story below (This answer is optional but greatly increases the quality of the AI response): </p>
            <textarea
            rows="5" cols="50"
            id = "friendLongAnswer" 
            name="friendLongAnswer" 
            value={friendLongAnswer} 
            onChange={(event) => setFriendLongAnswer(event.target.value)}>
            </textarea>
          </label>
                  </div>
              }
              {formType === 'pet' && petVisible &&
                  <div>
                    <label>
                  Tone:
                  <select value={toneType} onChange={handleToneTypeChange}>
                      <option value="detailed">Classic</option>
                      <option value="shakespearean">Shakespearean</option>
                      <option value="humorous">Humorous</option>
                      <option value="satirical">Satirical</option>
                      <option value="epic">Epic</option>
                      <option value="dark">Dark</option>
                      <option value="friendly">Friendly</option>
                  </select>
              </label>
              <label>
                  Structure:
                  <select value={poemStructure} onChange={handlePoemStructureChange}>
                      <option value="poem">Poem</option>
                      <option value="haiku">Haiku</option>
                  </select>
              </label>
                      <label>
            <p>Pets's Name:</p>
            <input id = "petName" 
            name="petName" 
            value={petName} 
            onChange={(event) => setPetName(event.target.value)}
            required></input>
          </label>
          <div className="radio">
            <p>Pets's Gender: </p>
        <label>
          <input
            type="radio"
            value="male"
            name="petGender"
            checked={petGender === 'male'}
            onChange={handlePetGender}
          />
          Male
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="female"
            name="petGender"
            checked={petGender === 'female'}
            onChange={handlePetGender}
          />
          Female
        </label>
      </div>
      <div className="radio">
        <p>Pet's Species: </p>
        <label>
          <input
            type="radio"
            value="dog"
            name="petSpecies"
            checked={petSpecies === 'dog'}
            onChange={handlePetSpecies}
          />
          Dog
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="cat"
            name="petSpecies"
            checked={petSpecies === 'cat'}
            onChange={handlePetSpecies}
          />
          Cat
        </label>
        <br></br>
      </div>
          <label>
            <p>Please tell us the breed of your pet. If not applicable put mixed:</p>
            <input id = "petBreed" 
            name="petBreed" 
            value={petBreed} 
            onChange={(event) => setPetBreed(event.target.value)}
            required></input>
          </label>
          <label>
            <p>One or two things you like about their personality:</p>
            <input id = "petTraits" 
            name="petTraits" 
            value={petTraits} 
            onChange={(event) => setPetTraits(event.target.value)}
            required></input>
          </label>
          <label>
            <p>What are your pets favorite things to do?</p>
            <input id = "petHobbies" 
            name="petHobbies" 
            value={petHobbies} 
            onChange={(event) => setPetHobbies(event.target.value)}
            required></input>
          </label>
          <label>
            <p>What color is your pet?</p>
            <input id = "petLooks" 
            name="petLooks" 
            value={petLooks} 
            onChange={(event) => setPetLooks(event.target.value)}
            required></input>
          </label>
          <label>
            <p>What is the name of the human your pet loves the most?</p>
            <input id = "petFriends" 
            name="petFriends" 
            value={petFriends} 
            onChange={(event) => setPetFriends(event.target.value)}
            required></input>
          </label>
          <label>
            <p>What was the funniest thing your pet ever did? Share the story below (This answer is optional but greatly increases the quality of the AI response): </p>
            <textarea
            rows="5" cols="50"
            id = "petLongAnswer" 
            name="petLongAnswer" 
            value={petLongAnswer} 
            onChange={(event) => setPetLongAnswer(event.target.value)}>
            </textarea>
          </label>
                  </div>
              } 
               {formType === 'mom' && momVisible &&
                  <div>
                    <label>
                  Tone:
                  <select value={toneType} onChange={handleToneTypeChange}>
                      <option value="detailed">Classic</option>
                      <option value="shakespearean">Shakespearean</option>
                      <option value="humorous">Humorous</option>
                      <option value="satirical">Satirical</option>
                      <option value="epic">Epic</option>
                      <option value="dark">Dark</option>
                      <option value="friendly">Friendly</option>
                  </select>
              </label>
              <label>
                  Structure:
                  <select value={poemStructure} onChange={handlePoemStructureChange}>
                      <option value="poem">Poem</option>
                      <option value="haiku">Haiku</option>
                  </select>
              </label>
                      <label>
            <p>Mothers's Name:</p>
            <input id = "momName" 
            name="momName" 
            value={momName} 
            onChange={(event) => setMomName(event.target.value)}
            required></input>
          </label>
          <div className="radio">
        <p>Estimate their age: </p>
        <label>
          <input
            type="radio"
            value="young"
            name="momAge"
            checked={momAge === 'young'}
            onChange={handleMomAge}
          />
          Young 20-30
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="adult"
            name="momAge"
            checked={momAge === 'adult'}
            onChange={handleMomAge}
            />
          Adult 30-65
        </label>
        <br></br>
        <label>
          <input
            type="radio"
            value="elder"
            name="momAge"
            checked={momAge === 'elder'}
            onChange={handleMomAge}
            />
          Elder 65+
        </label>
      </div>
          <label>
            <p>What does she look like? </p>
            <input id = "momLooks" 
            name="momLooks" 
            value={momLooks} 
            onChange={(event) => setMomLooks(event.target.value)}
            required></input>
          </label>
          <label>
            <p>One or two things you like about her personality:</p>
            <input id = "momTraits" 
            name="momTraits" 
            value={momTraits} 
            onChange={(event) => setMomTraits(event.target.value)}
            required></input>
          </label>
          <label>
            <p>What are 1 or 2 hobbies your mom likes to do?</p>
            <input id = "momHobbies" 
            name="momHobbies" 
            value={momHobbies} 
            onChange={(event) => setMomHobbies(event.target.value)}
            required></input>
          </label>
          <label>
            <p>What are the names of her childen?</p>
            <input id = "momKids" 
            name="momKids" 
            value={momKids} 
            onChange={(event) => setMomKids(event.target.value)}
            required></input>
          </label>
          <label>
            <p>What is their favorite place to travel or hang out?</p>
            <input id = "momPlace" 
            name="momPlace" 
            value={momPlace} 
            onChange={(event) => setMomPlace(event.target.value)}
            required></input>
          </label>
          <label>
            <p>Recall a fun or loving time you had together. Share the story below (This answer is optional but greatly increases the quality of the AI response): </p>
            <textarea
            rows="5" cols="50"
            id = "momLongAnswer" 
            name="momLongAnswer" 
            value={momLongAnswer} 
            onChange={(event) => setMomLongAnswer(event.target.value)}
            >
            </textarea>
          </label>
                  </div>
              } 
               {formType === 'dad' && dadVisible &&
                  <div>
                    <label>
                  Tone:
                  <select value={toneType} onChange={handleToneTypeChange}>
                      <option value="detailed">Classic</option>
                      <option value="shakespearean">Shakespearean</option>
                      <option value="humorous">Humorous</option>
                      <option value="satirical">Satirical</option>
                      <option value="epic">Epic</option>
                      <option value="dark">Dark</option>
                      <option value="friendly">Friendly</option>
                  </select>
              </label>
              <label>
                  Structure:
                  <select value={poemStructure} onChange={handlePoemStructureChange}>
                      <option value="poem">Poem</option>
                      <option value="haiku">Haiku</option>
                  </select>
              </label>
                        <label>
              <p>Father's Name:</p>
              <input id = "dadName" 
              name="dadName" 
              value={dadName} 
              onChange={(event) => setDadName(event.target.value)}
              required></input>
            </label>
            <div className="radio">
          <p>Estimate their age: </p>
          <label>
            <input
              type="radio"
              value="young"
              name="dadAge"
              checked={dadAge === 'young'}
              onChange={handleDadAge}
            />
            Young 20-30
          </label>
          <br></br>
          <label>
            <input
              type="radio"
              value="adult"
              name="dadAge"
              checked={dadAge === 'adult'}
              onChange={handleDadAge}
              />
            Adult 30-65
          </label>
          <br></br>
          <label>
            <input
              type="radio"
              value="elder"
              name="dadAge"
              checked={dadAge === 'elder'}
              onChange={handleDadAge}
              />
            Elder 65+
          </label>
        </div>
            <label>
              <p>What does he look like? </p>
              <input id = "dadLooks" 
              name="dadLooks" 
              value={dadLooks} 
              onChange={(event) => setDadLooks(event.target.value)}
              required></input>
            </label>
            <label>
              <p>One or two things you like about his personality:</p>
              <input id = "dadTraits" 
              name="dadTraits" 
              value={dadTraits} 
              onChange={(event) => setDadTraits(event.target.value)}
              required></input>
            </label>
            <label>
              <p>What are 1 or 2 hobbies your dad likes to do?</p>
              <input id = "dadHobbies" 
              name="dadHobbies" 
              value={dadHobbies} 
              onChange={(event) => setDadHobbies(event.target.value)}
              required></input>
            </label>
            <label>
              <p>What are the names of his childen?</p>
              <input id = "dadKids" 
              name="dadKids" 
              value={dadKids} 
              onChange={(event) => setDadKids(event.target.value)}
              required></input>
            </label>
            <label>
              <p>What is your dad's favorite place to travel or hang out?</p>
              <input id = "dadPlace" 
              name="dadPlace" 
              value={dadPlace} 
              onChange={(event) => setDadPlace(event.target.value)}></input>
            </label>
            <label>
              <p>Recall a fun or loving time you had together: Share the story below (This answer is optional but greatly increases the quality of the AI response): </p>
              <textarea
              rows="5" cols="50"
              id = "dadLongAnswer" 
              name="dadLongAnswer" 
              value={dadLongAnswer} 
              onChange={(event) => setDadLongAnswer(event.target.value)}>
              </textarea>
            </label>
                    </div>
                } 
                <br />
                <br />
                { !(formType === 'self') && 
                <div>
                  <input className="button" type="submit" value="Submit"/>
                <br></br>
                <ReCAPTCHA 
                className="recaptcha"
                sitekey="6Lckw54lAAAAAFSwLOcwg56NAsomQ2AG4f4ROPfk"
                size="invisible"
                badge="inline"
                ref={reRef}/>
                </div>
                  
                }
            </form>
        </div>
      }
      {isAnimating && 
      <Animation></Animation> }
      </div>
      
    );
};



function App() {
  let [output, setOutput] = useState('')
  let [isVisible, setIsVisible] = useState(true)
  let [type, setOutputType] = useState('')

  
  return (
    <fieldset className="app_fieldset">
      {isVisible &&
      <Form 
      hideForm = {isVisible => setIsVisible(isVisible)} 
      grabPoem = {output => setOutput(output)}
      grabType = {type => setOutputType(type)}>
      </Form>
      }
      {(isVisible===false) &&
      <div>
      <Output output={output}></Output>
      <EmailHeader></EmailHeader>
      <EmailMe poem={output} type={type}></EmailMe>
    </div>
      }
      
    </fieldset>
  );
}

export default App;
